export default __webpack_public_path__ + "static/media/kitchen3-afterA-480w.05b81085.avif";